import { Action } from '@ngrx/store';
import { LandLineListInterface } from '../../models/land-line-list.interface';

export enum ESetSelectedLandLineActions {
  SetSelectedLandLine = '[LANDLINE] Set selected land line',
}

export class SetSelectedLandLine implements Action {
  public readonly type = ESetSelectedLandLineActions.SetSelectedLandLine;
  constructor(public payload?: LandLineListInterface) {

  }
}

export type SelectedLandlineActions = SetSelectedLandLine;
